import { render, staticRenderFns } from "./Disenrollments.vue?vue&type=template&id=54052195&scoped=true&"
import script from "./Disenrollments.vue?vue&type=script&lang=js&"
export * from "./Disenrollments.vue?vue&type=script&lang=js&"
import style0 from "./Disenrollments.vue?vue&type=style&index=0&id=54052195&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54052195",
  null
  
)

export default component.exports